import type {ErrorObject} from '@vuelidate/core';
import {unref} from 'vue';

const dutchErrors: Record<string, string> = {
	required: 'Dit veld is verplicht',
	minLength: 'Dit veld moet minstens {min} karakters bevatten',
	maxLength: 'Dit veld mag maximaal {max} karakters bevatten',
	minValue: 'De waarde moet minimaal {min} zijn',
	maxValue: 'De waarde moet maximaal {max} zijn',
	integer: 'De waarde moet een heel getal zijn, zonder decimalen',
	numeric: 'De waarde moet numeriek zijn',
	email: 'Dit is geen geldig e-mailadres',
	dutchZipCode: 'Vul hier een geldige postcode in.',
	requiredResponsible: 'Dit veld is verplicht'
};

export const getDutchError = ($error: ErrorObject) => {
	let message = dutchErrors[$error.$validator];

	if (!message || message.length === 0) {
		return unref($error.$message);
	}

	Object.keys($error.$params).forEach((paramName) => {
		const paramValue = ($error.$params as Record<string, unknown>)[paramName];

		if (typeof paramValue === 'string' || typeof paramValue === 'number') {
			message = message.replace(`{${paramName}}`, `${paramValue}`);
		}
	});

	return message;
};
